module.exports = require("./ln-CF.d.ts");